import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { Container, Typography } from "@material-ui/core";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

import { ROUTES } from "../../actions/app/constants";
import { setActiveRoute } from "../../actions/app/navigation";
import { setCreativeApiError } from "../../actions/app/creatives";
import StaticStepper from "../../components/Steppers/StaticStepper";

// Google Analytics module
import ReactGA from "react-ga";

// initialize react-ga module
ReactGA.initialize("UA-172736709-1");
ReactGA.pageview("/staticimage");

const useStyles = makeStyles((theme) => ({
  route: {
    marginTop: theme.spacing(2),
    position: "relative",
    minHeight: "84vh"
  },
  link: {
    color: "#000",
    textDecoration: "none"
  },
  back: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  backIcon: {
    marginRight: 8
  },
  stepper: {
    paddingTop: "6vh"
  }
}));

const Static = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveRoute(ROUTES.CREATIVE_TRAFFICKER));
    dispatch(setCreativeApiError(new Error(), false));
  }, [dispatch]);

  return (
    <Container maxWidth="xl" className={classes.route}>
      <Link to="/" className={classes.link}>
        <div className={classes.back}>
          <ArrowBackIcon className={classes.backIcon} fontSize="small" />
          <Typography variant="body2">Return to placement selection</Typography>
        </div>
      </Link>
      <StaticStepper className={classes.stepper} />
    </Container>
  );
};

export default Static;
